import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { ChatPanelComponent } from './chat-panel.component';
import { ChatPanelService } from './chat-panel.service';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        ChatPanelComponent
    ],
    providers   : [
        ChatPanelService
    ],
    imports     : [
        SharedModule,

        FuseSharedModule
    ],
    exports     : [
        ChatPanelComponent
    ]
})
export class ChatPanelModule
{
}
